(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["porduct-features"] && !window.DesignMode) return;
  try {
    
  const disclosures = document.querySelectorAll(".pf-feature-block");
  const originalPic = document.querySelector("#pf-center-pic").src;  
  const autoplay = document.querySelector('.pf-content-container').dataset.autoplay;
  let cycle = 0;
  let pfTransition = '';
  let pfCurrent = '';
  
  for(const element of disclosures) {
    element.addEventListener("mouseover", () => {
      makeInactive();
      updatePics(element.dataset.picture);
      element.classList.remove('pf-inactive');
      element.classList.add('pf-active');
    });

    element.addEventListener('mouseout', () => {
      updatePics(originalPic);     
      element.classList.remove('pf-active');
      element.classList.add('pf-inactive');
    });
  }

  function makeInactive() {
    for(const element of disclosures) {
      element.classList.add('pf-inactive');
      element.classList.remove('pf-active');
    }
  }

  function updatePics(newSrc) {
    if(pfCurrent !== "") {
      pfTransition = newSrc;      
      return;
    }
    
    pfCurrent = newSrc;
    const imageA = document.querySelector("#pf-center-pic");
    const imageB = document.querySelector("#pf-center-pic-ghost");
    const backgroundA = document.querySelector('#pf-background');
    const backgroundB = document.querySelector('#pf-background-ghost');    
    
    const nextImage = imageA.classList.contains('pf-hidden') ? imageA : imageB;
    const prevImage = imageA.classList.contains('pf-visible') ? imageA : imageB;
    const nextBackground = backgroundA.classList.contains('pf-hidden') ? backgroundA : backgroundB;
    const prevBackground = backgroundA.classList.contains('pf-visible') ? backgroundA : backgroundB;
    
    nextImage.src = newSrc;
    nextBackground.src = newSrc;
    
    setTimeout(()=> {
      nextImage.classList.add('pf-visible');
      nextBackground.classList.add('pf-visible');
      nextImage.classList.remove('pf-hidden');
      nextBackground.classList.remove('pf-hidden');
      
      prevImage.classList.add('pf-hidden');
      prevBackground.classList.add('pf-hidden');
      prevImage.classList.remove('pf-visible');
      prevBackground.classList.remove('pf-visible');
    
      setTimeout(()=> {
        prevImage.src = newSrc;
        prevBackground.src = newSrc;

        pfCurrent = '';
        if(pfTransition !== '') {          
          let argument = pfTransition;
          pfTransition = '';          
          updatePics(argument);
        }
      }, 300);
    }, 300);
    
  }

  
  function changeActive() {    
    makeInactive();
    const element = disclosures[cycle];
    updatePics(element.dataset.picture); 
    element.classList.remove('pf-inactive');
    element.classList.add('pf-active');
    
    cycle = cycle < disclosures.length - 1? cycle + 1 : 0;     
  }
  if( autoplay == "true") {
    setInterval(changeActive, 2500);  
  }
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-carousel"] && !window.DesignMode) return;
  try {
      
  const buttons = document.querySelectorAll(".video_container");  
  
  for(const container of buttons) {
    container.addEventListener('click', () => {
      const video = container.querySelector('video');
      const button = container.querySelector('.play-button');      
      const pauseIcon = document.querySelector('.video_carousel').dataset.pause;
      const playIcon = document.querySelector('.video_carousel').dataset.play;

      if (video.paused) {
        video.play();
        button.src = pauseIcon;
        button.style.opacity = 0;
      } else {
        video.pause();
        button.src = playIcon;
        button.style.opacity = 0.6;
      }      
    });
  } 

  

  } catch(e) { console.error(e); }
})();
})();
